import {REGION_NAMES, REGION_CURRENCY_MAP} from '../constants/countries';
import {GOOGLE_CLOUD_FUNCTIONS_URL} from '../constants/network';
import {ValueOf} from './types';

const DEFAULT_REGION = 'EU';

type CustomStoreCounties = keyof typeof REGION_CURRENCY_MAP;
type RegionNames = keyof typeof REGION_NAMES;

type CloudFunctionResponse = {
  country: CustomStoreCounties;
  region: string;
  city: string;
  cityLatLong: string;
  userIP: string;
};

export type StoreRegionData = {
  currency: ValueOf<typeof REGION_CURRENCY_MAP>;
  region: CustomStoreCounties;
  regionName: RegionNames;
};

export const getStoreDataOptions = (): StoreRegionData[] =>
  Object.keys(REGION_CURRENCY_MAP).map((key) => ({
    region: key,
    currency: REGION_CURRENCY_MAP[key],
    regionName: REGION_NAMES[key],
  }));

export const getUserCurrency = async (): Promise<StoreRegionData> => {
  try {
    const res = await fetch(
      `${GOOGLE_CLOUD_FUNCTIONS_URL}/ip-reverse-geolocation`
    );
    const json = (await res.json()) as CloudFunctionResponse;
    const {country} = json;

    const customCurrency = REGION_CURRENCY_MAP[country];
    const regionName = REGION_NAMES[country];

    return {
      currency: customCurrency || REGION_CURRENCY_MAP.EU,
      region: customCurrency ? country : DEFAULT_REGION,
      regionName: regionName || REGION_NAMES.EU,
    } as const;
  } catch (err) {
    return {
      currency: REGION_CURRENCY_MAP.EU,
      region: DEFAULT_REGION,
      regionName: REGION_NAMES.EU,
    } as const;
  }
};

type UserRegionData = {
  country: string;
  city: string;
};

export const getUserLocation = async (): Promise<UserRegionData> => {
  try {
    const res = await fetch(
      `${GOOGLE_CLOUD_FUNCTIONS_URL}/ip-reverse-geolocation`
    );
    const json = (await res.json()) as CloudFunctionResponse;
    const {country, city} = json;

    return {
      country,
      city,
    } as const;
  } catch (err) {
    return {
      country: '',
      city: '',
    } as const;
  }
};
